<template>
    <div class="friendZonePage">
        <div class="friendZoneHeader">{{ $t('friendZone.title') }}</div>
        <div class="friendZoneOrientationMsg">
            <div>{{ $t('friendZone.rotateMobile') }}</div>
            <div class="msgImage">
                <font-awesome-icon :icon="icons.mobile" class="fa-fw fa-3x"></font-awesome-icon>
            </div>
        </div>
        <div class="friendZoneContainer">
            <FriendZone :data="myData" :display="toggleInfoToDisplay">
                <template v-slot:header>
                    <div class="fzName">{{ myName }}</div>
                    <div class="fzActions">
                        <v-btn-toggle v-model="toggleInfoToDisplay" mandatory dense color="primary">
                            <v-btn value="portfolios" :disabled="portfoliosDisabled">
                                <font-awesome-icon :icon="icons.portfolio" class="fa-fw"></font-awesome-icon>
                                <span v-if="showBtnText" class="ml-1">Portfolios</span>
                            </v-btn>
                            <v-btn value="distribution" :disabled="portfoliosDisabled">
                                <font-awesome-icon :icon="icons.distribution" class="fa-fw"></font-awesome-icon>
                                <span v-if="showBtnText" class="ml-1">Distribution</span>
                            </v-btn>
                            <v-btn value="transactions" :disabled="transactionsDisabled">
                                <font-awesome-icon :icon="icons.transactions" class="fa-fw"></font-awesome-icon>
                                <span v-if="showBtnText" class="ml-1">Transactions</span>
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                </template>
            </FriendZone>
            <FriendZone :data="friendData" :display="toggleInfoToDisplay">
                <template v-slot:header>
                    <v-autocomplete
                        v-model="selectedFriend"
                        :items="friendList"
                        item-text="fullName"
                        item-value="id"
                        :label="$t('friendZone.selectAFriend')"
                        outlined
                        dense
                        hide-details
                    ></v-autocomplete>
                    <FriendListManagerDialog></FriendListManagerDialog>
                </template>
            </FriendZone>
        </div>
    </div>
</template>

<script>
import { faMobile } from '@fortawesome/pro-regular-svg-icons';
import UserDataHelperMixin from '../../infra/UserDataHelperMixin';
import { getUserAllFriendship, getUserFriendDataPackage } from '../../services/SharingService';
import { authComputed } from '../../store/helpers/AuthenticationHelper';
import FriendZone from './FriendZone.vue';
import FriendListManagerDialog from './FriendListManagerDialog.vue';
import Friend from '../../models/Friend';
import DashboardOverviewMixin from '../../components/home/dashboard/DashboardOverviewMixin';
import { faChartPie, faHandshake, faSuitcase } from '@fortawesome/pro-light-svg-icons';

export default {
    mixins: [UserDataHelperMixin, DashboardOverviewMixin],
	components: { FriendZone, FriendListManagerDialog },
    data() {
        return {
            icons: {
                mobile: faMobile,
                portfolio: faSuitcase,
                distribution: faChartPie,
                transactions: faHandshake
            },
            portfoliosDisabled: false,
            transactionsDisabled: false,
            toggleInfoToDisplay: 'portfolios',
            selectedFriend: undefined,
            friendData: undefined
        }
    },
    computed: {
        ...authComputed,
        myName() {
            return this.user.fullname();
        },
        userPortfolios() {
            return this.$store.getters.portfolioList;
        },
        myPortfoliosTotal() {
            return {
                portfolioSummary: this.$store.getters.portfolioSummary,
                portfolios: this.userPortfolios
            };
        },
        friendList() {
            return this.$store.getters.friendList.filter(f => f.status === 'approuved');
        },
        showBtnText() {
            return this.$vuetify.breakpoint.mdAndUp;
        }
    },
    mounted() {
        getUserAllFriendship().then(response => {
            const friendList = response.map(f => new Friend({ ...f }));
            this.$store.dispatch('setFriendList', { friendList });
        });
    },
    methods: {
        manageFriendList() {
            console.log('Manage Friend List clicked');
        }
    },
    watch: {
        friendList(newList) {
            if (newList.length > 0 && !this.selectedFriend) {
                this.selectedFriend = newList[0].id;
            }
        },
        selectedFriend(friendUserId) {
            getUserFriendDataPackage({ friendUserId }).then(dataPackage => {
                this.friendData = dataPackage
                //this.toggleInfoToDisplay = dataPackage.hasPortfoliosTotalAmount ? 'portfolios' : 'distribution';
                this.portfoliosDisabled = !dataPackage.hasPortfoliosTotalAmount;
                this.transactionsDisabled = !dataPackage.hasTransactions;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.friendZonePage {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 20px 40px;
    .friendZoneHeader {
        padding: 20px;
        color: #FFF;
        background-color: var(--darkBG);
        font-size: 24px;
        font-weight: bold;
        border-radius: 8px;
    }
    .friendZoneContainer {
        height: 90%;
        border: 1px solid var(--midGray);
        border-radius: 8px;
        display: flex;
        .fzName {
            font-size: 1.2em;
            font-weight: bold;
        }
        .fzActions {
            ::v-deep .v-btn__content {
                text-transform: none;
                letter-spacing: normal;
            }
        }
    }
    .friendZoneOrientationMsg {
        display: none;
        color: var(--v-agora-base);
        background: var(--v-agorabg-base);
        border: 1px solid var(--v-agora-base);
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 16px;
        text-align: center;
        font-size: 1.2em;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        .msgImage {
            animation: rotate45Loop 2s infinite;
            transition: transform 0.5s ease;
        }
    }
    @media screen and (max-width: $phone){
        .friendZoneHeader {
            flex: none;
        }
        .friendZoneContainer{
            display: none;
        }
        .friendZoneOrientationMsg {
            display: flex;
            flex: 1;
        }
    }
    @media only screen and (max-device-width: 1024px) and (orientation:landscape) {
        padding: 10px 5px;
        .friendZoneHeader {
            font-size: 1rem;
            padding: 8px 20px;
        }
        .friendZoneContainer {
            height: 100%;
        }
    }
}
@keyframes rotate45Loop {
    0%   { transform: rotate(0deg); }
    50%  { transform: rotate(-90deg); }
    100% { transform: rotate(0deg); }
}
</style>